import { useNavigate } from '@tanstack/react-router';
import { Button } from '@yembo/yemblocks-core';
import ErrorImage from 'src/assets/img/page-not-found.svg';
import { useDocumentTitle } from 'src/react/_hooks/useDocumentTitle';
import { AppScreen } from 'src/react/_shared/AppScreen';

export const PageNotFound = () => {
  const navigate = useNavigate();
  useDocumentTitle('Page not found');

  return (
    <AppScreen className='page-not-found'>
      <div className='controls-wrapper'>
        <div>
          <h3>Something's not quite right...</h3>
          <span>This page was not found on our servers.</span>
        </div>

        <Button kind='outline' size='medium' onClick={() => navigate({ to: '/jobs' })} text='Go to Jobs' />
      </div>

      <img src={ErrorImage} alt='404' />
    </AppScreen>
  );
};
